import { create } from 'zustand';

interface AntispamState {
  isValid: boolean;
  setAntispamResults: (isValid: boolean) => void;
}

export const useAntispam = create<AntispamState>((set) => ({
  isValid: false,
  setAntispamResults: (isValid) => set({ isValid }),
}));
